<template>
  <div
    ref="sidenav"
    :id="isdisplay ? 'side-nav-collapsed' : 'side-nav-expanded'"
    :style="isdisplay ? 'width:0px;border:0;' : 'width:200px;border:0;'"
    style="background: linear-gradient(to right, #0f2027, #203a43, #2c5364);border-right:0.5px solid #c3c5c7bb;"
  >
    <div class="close_button" @click="closeSidenav()"></div>

    <b-card no-body class="left-nav" style="padding-bottom: 50px;">
      <div class="logo-container">
        <img src="logo.png" alt="Logo" class="image-logo" />
      </div>

      <b-row no-gutters class="side-items" style="margin-top: 10px;width:100%;">
        <router-link
          v-for="(item, index) in filteredMenuItems"
          :key="index"
          :to="item.link"
          class="col-12 nav-items"
          style="width:100%;"
        >
          <b-row
            no-gutters
            class="item-list"
            style="width: 100%;padding-left:10px;padding-top:5px;padding-bottom:5px;"
            :id="`popover-${index + 1}-right-home`"
          >
            <div class="icon-container">
              <i :class="item.icon" class="menu-icon"></i>
            </div>
            <div class="text-container" style="padding-top:3px;">{{ item.name }}</div>
          </b-row>
        </router-link>
      </b-row>

      <!-- Logout -->
      <b-row
        no-gutters
        class="item-list nav-items"
        @click="Logout()"
        style="cursor: pointer; padding-left: 20px;padding-top:5px;padding-bottom:10px;"
      >
        <b-col md="auto" style="width: 10%;">
          <i class="fas fa-lock" style="font-size: 1em;"></i>
        </b-col>
        <b-col md="auto" style="width: 80%; text-align: left; margin-left: 5%; font-weight: normal;">
          Log Out
        </b-col>
      </b-row>
    </b-card>

    <!-- Footer -->
    <div class="footer" style="background: linear-gradient(to right, #0f2027, #203a43, #2c5364) !important;">
      <span class="left" style="background: linear-gradient(to right, #0f2027, #203a43, #2c5364) !important;color:white;">
        © THE EAGLE {{ new Date().getFullYear() }} Developed by
        <a
          href="https://nervetecheth.com"
          class="author"
          target="_blank"
          rel="noopener noreferrer"
        >
          AMA
        </a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      counter: 1,
      isdisplay: false,
      menuItems: [
        { name: 'Dashboard', icon: 'mdi mdi-chart-pie', link: '/admin', roles: ['Admin', 'User'] },
        { name: 'Users', icon: 'mdi mdi-account-group', link: '/manage/users', roles: ['Admin'] },
        { name: 'Country', icon: 'mdi mdi-earth', link: '/Country', roles: ['Admin'] },
        { name: 'Float', icon: 'mdi mdi-cash-multiple', link: '/rate', roles: ['Admin', 'User'] },
        { name: 'Transaction', icon: 'mdi mdi-swap-horizontal', link: '/manage/transaction', roles: ['User', 'Admin'] },
        { name: 'Summary', icon: 'mdi mdi-file-chart', link: '/create/transaction', roles: ['User', 'Admin'] },
        { name: 'Profile', icon: 'fas fa-user', link: '/account/and/profile', roles: ['Admin'] },
      ]
    };
  },
  mounted() {
    window.Fire?.$on('hide-or-unhide-mobile-side', () => {
      this.closeSidenav();
    });
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  computed: {
    filteredMenuItems() {
      const userRole = this.$store.getters.role;
      return this.menuItems.filter(item => item.roles.includes(userRole));
    }
  },
  methods: {
    closeSidenav() {
      this.isdisplay = !this.isdisplay;

      if (!this.isdisplay) this.counter = 0;
      window.Fire.$emit('hide-or-unhide-sidenav');
    },
    handleClickOutside(event) {
      const sideNav = this.$refs.sidenav;
      const isMobile = window.innerWidth <= 768;
      const clickedCloseButton = event.target.closest('.navcloser');
      
if (!sideNav.contains(event.target) && !this.isdisplay && isMobile && !clickedCloseButton) {
  this.closeSidenav();
}
    },
    Logout() {
      this.$store.dispatch('Logout').then(() => {
        this.$router.push('/login');
      });
    }
  }
};
</script>

<style scoped>
#side-nav-expanded,
#side-nav-collapsed {
  transition: width 0.3s ease;
  overflow-y: auto;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 1000;
  background-color: white;
  box-shadow: 3px 0 10px rgba(0, 0, 0, 0.1);
  border-right: 1px solid #ddd;
}

#side-nav-collapsed .text-container {
  display: none;
  width: 0;
}

.image-logo {
  border-radius: 50%;
  border: 2px solid gold;
  box-shadow: 0 0 1px gold, 0 0 5px gold, 0 0 10px gold;
  height: 120px;
  width: 120px;
  object-fit: cover;
  margin-top: -10px;
}

.logo-container {
  text-align: center;
  padding: 1rem 0;
  margin: 0;
}

.icon-container {
  width: 30px;
  padding-left: 10px;
}

.text-container {
  width: calc(100% - 40px);
  text-align: left;
  padding-left: 10px;
}

.menu-icon {
  font-size: 1.2em;
  color: white;
}

.nav-items {
  margin-bottom: 15px;
  text-align: left;
  margin-left: 0px;
  color: white;
  text-decoration: none;
  transition: background-color 0.2s ease;
}

.item-list:hover,
.router-link-exact-active .item-list {
  background: #c3c5c79a;
  color: white;
  font-weight: bold;
  border-left: 5px solid #00c3ff;
  box-shadow: 0 3px 6px rgba(0, 195, 255, 0.3);
  transform: scale(1.02);
  transition: all 0.3s ease;
}

.left-nav {
  overflow-y: auto;
  overflow-x: hidden;
  background-color: transparent;
  border: 0;
  margin-top: 2px;
}

.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 200px;
  background: white;
  border-top: 1px solid #ddd;
  padding: 12px 20px;
  font-size: 0.75em;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.author {
  text-decoration: none;
  color: #00d1b2;
  transition: color 0.3s ease-in-out;
}

.author:hover {
  color: #4facfe;
  text-shadow: 0px 0px 5px rgba(79, 172, 254, 0.8);
}

@media (max-width: 768px) {
  #side-nav-expanded,
  #side-nav-collapsed {
    width: 0px;
  }

  #side-nav-expanded .text-container,
  #side-nav-collapsed .text-container {
    display: inline;
  }

  .footer {
    font-size: 0.9em;
    flex-direction: column;
    text-align: center;
  }
}
</style>
